import React from 'react';
import { useApolloClient } from '@apollo/client';

import styles from './rightSidebarStyles.scss';

import Attachments from 'buyside/components/presentation/IdeaShowPage/RightSidebar/Attachments/attachments';
import AuthorPosts from 'buyside/components/presentation/IdeaShowPage/RightSidebar/RelatedPosts/authorPosts';
import EntityIdeas from 'buyside/components/presentation/IdeaShowPage/RightSidebar/EntityIdeas/entityIdeas';
import IdeaInformation from 'buyside/components/presentation/IdeaShowPage/RightSidebar/IdeaInformation/ideaInformation';
import PositionInformation from 'buyside/components/presentation/IdeaShowPage/RightSidebar/PositionInformation/positionInformation';
import PricingDetails from 'buyside/components/presentation/IdeaShowPage/RightSidebar/PricingDetails/pricingDetails';
import QuickPositions from 'buyside/components/presentation/IdeaShowPage/RightSidebar/QuickPositions/quickPositions';
import RelatedIdeas from 'buyside/components/presentation/IdeaShowPage/RightSidebar/RelatedIdeas/relatedIdeas';
import ReturnPerformance from 'buyside/components/presentation/IdeaShowPage/RightSidebar/ReturnPerformance/returnPerformance';
import YouTubePlayer from 'buyside/components/presentation/YouTubePlayer/youtubePlayer';

import { IdeaCoreQuery } from 'interfaces/graphql-typings';

const IdeaCore = require('buyside/graphql/queries/ideaShowPage/IdeaCore');

const RightSidebar: React.FC<{
  ideaId: string;
  isPublic: boolean;
  loading: boolean;
}> = ({ ideaId, isPublic, loading }) => {
  const client = useApolloClient();

  const cachedIdea = client.readQuery<IdeaCoreQuery>({
    query: IdeaCore,
    variables: { ideaId }
  })?.idea;

  const youtubeIds = cachedIdea?.youtubeIds;

  return (
    <div>
      <div className={styles.tableItem}>
        <PricingDetails ideaId={ideaId} loading={loading} />
      </div>
      <div className={styles.tableItem}>
        <ReturnPerformance ideaId={ideaId} loading={loading} />
      </div>
      <div className={styles.tableItem}>
        <IdeaInformation ideaId={ideaId} loading={loading} />
      </div>
      {!isPublic && (
        <div className={styles.tableItem}>
          <QuickPositions ideaId={ideaId} />
        </div>
      )}
      <div className={styles.tableItem}>
        <PositionInformation ideaId={ideaId} loading={loading} />
      </div>
      <div className={styles.tableItem} id="attachments">
        <Attachments ideaId={ideaId} loading={loading} />
      </div>
      {youtubeIds &&
        youtubeIds.map(
          (id: string): React.ReactElement => (
            <YouTubePlayer key={id} width={345.6} height={210.6} videoId={id} />
          )
        )}
      <AuthorPosts ideaId={ideaId} />
      {!isPublic && (
        <div className={styles.tableLinks}>
          <EntityIdeas ideaId={ideaId} />
        </div>
      )}
      <div className={styles.tableItem}>
        <RelatedIdeas ideaId={ideaId} isPublic={isPublic} loading={loading} />
      </div>
    </div>
  );
};

export default RightSidebar;
